import { PageLoading } from '@psl/appComponents/PageLoading';
import {
  kDefaultPageDescription,
  kDefaultPageTitle,
} from '@psl/appComponents/seo/PageMeta.web';
import type { MainPageProps } from '@psl/flows/main/MainPageContent';
import { wrapLazyNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const MainPageContent = lazy(() => import('./MainPageContent'));

export const MainPage = wrapLazyNavigatorScreen(
  (props: MainPageProps) => {
    return <MainPageContent {...props} />;
  },
  {
    headerShown: false,
    animationEnabled: false,
    suspenseFallback: <PageLoading style={{ backgroundColor: '#000' }} />,
  },
  {
    title: kDefaultPageTitle,
    description: kDefaultPageDescription,
  },
);
